import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import TalkInformation from './TalkInformation';
import './TalkDetail.css';

export default class TalkDetail extends React.Component {
    async componentDidMount() {
        window.scrollTo(0, 0);
        // await this.props.fetchTalkDetails(this.props.match.params.id);
    }

    onBackButtonClick = () => this.props.goBackAction();

    onSpeakerClick = speakerId => this.props.pushAction(`/speakers/${speakerId}`);

    render() {
        const nullTalk = <h4 className="title is-4">Oops ! There is no such talk.</h4>;
        const orderedTalks =
            this.props.talks.length > 0 ? orderBy(this.props.talks, 'order', ['asc']) : [];
        const content =
            this.props.talks.length === 0 || this.props.speakers.length === 0 ? (
                nullTalk
            ) : (
                <div className="card">
                    {this.props.fetchingProgram ? (
                        <i
                            className="fa fa-spinner fa-spin fa-3x fa-fw"
                            style={{ color: '#7500c0' }}
                        />
                    ) : (
                        <div>
                            <div className="columns is-multiline is-centered">
                                {orderedTalks.map(talk => {
                                    const speakers = this.props.speakers.filter(speaker =>
                                        talk.speakers.some(speakerId => speakerId === speaker.id)
                                    );
                                    return (
                                        <TalkInformation
                                            id={talk.id}
                                            key={talk.id}
                                            liveCoding={talk.livecoding || false}
                                            onSpeakerClickHandler={this.onSpeakerClick}
                                            proficiency={talk.proficiency || ''}
                                            speakers={speakers}
                                            summary={talk.description || ''}
                                            talkType={talk.talkType || ''}
                                            technicalOrBusiness={talk.technicalOrBusiness || ''}
                                            title={talk.title || ''}
                                            track={talk.track}
                                            video={talk.youtube || ''}
                                        />
                                    );
                                })}
                            </div>
                            <button
                                className="button is-large is-rounded btn-submit back-btn"
                                onClick={this.onBackButtonClick}
                                type="button"
                            >
                                Back
                            </button>
                        </div>
                    )}
                </div>
            );
        return (
            <div id="talk-details-section">
                <section className="section sp-form" id="talk-details">
                    <div className="container sp-container">{content}</div>
                </section>
            </div>
        );
    }
}

TalkDetail.propTypes = {
    fetchingProgram: PropTypes.bool.isRequired,
    goBackAction: PropTypes.func.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    pushAction: PropTypes.func.isRequired,
    speakers: PropTypes.arrayOf(PropTypes.any).isRequired,
    talks: PropTypes.arrayOf(PropTypes.any).isRequired
};
